import type { Venue } from '@/types';

export interface VenueDTO {
  id: number; // Venue ID
  name: string; // Name of the venue
  address?: string; // Street address
  address2?: string; // Secondary address line
  city?: string; // City
  zip?: string; // Postal code
  country?: string; // Country
  email?: string; // Contact email
  telephone?: string; // Contact telephone number
  website?: string; // Venue website URL
  num_events: number | string; // Number of events at this venue. Warning: includes all events including past events.
  lat_lng?: string; // Latitude and longitude as a comma-separated string ("lat,lng")
}

/**
 * Transforms a VenueDTO object into a Venue object used in the frontend.
 * @param dto - The VenueDTO object received from the backend.
 * @returns The transformed Venue object.
 */
export function mapDtoToVenue(dto: VenueDTO): Venue {
  const { lat_lng, ...rest } = dto;
  return {
    ...rest,
    num_events: Number(dto.num_events),
    ...(lat_lng !== undefined && { lat_lng }),
  };
}

/**
 * Transforms an array of VenueDTO objects into an array of Venue objects.
 * @param dtos - The array of VenueDTO objects received from the backend.
 * @returns The transformed array of Venue objects.
 */
export function mapDtosToVenues(dtos: VenueDTO[]): Venue[] {
  return dtos.map(mapDtoToVenue);
}
